import { styled } from "@mui/material";

export const Section = styled('div')(({ theme }) => (props) => ({
    padding: '24px 24px 24px 96px  ',
    [theme.breakpoints.down('md')]: {
        padding: '24px 24px 24px 48px  '
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px 24px 12px 24px  '
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px 12px 6px 12px  '
    },
}))